import { Price } from "../models/Price";
import { PriceCols } from "../shared/Consts";
import React from "react";
import Utils from "../portlibs/PortUtils";
import { usePath } from "../libs/path/PathProvider";
import Prices from "../models/Prices";
import PortUtils from "../portlibs/PortUtils";
import Table from "../gui/Table/Table";
import usePortfolio from "../hooks/PortfolioProvider";
import ConfigToolbar from "../components/config/ConfigToolbar";

const COLS = [PriceCols.ticker, PriceCols.name, PriceCols.sector, PriceCols.date, PriceCols.price, PriceCols.payout, PriceCols.yield, PriceCols.frequency]
export default function ConfigPage(){
    const {query,setHash} = usePath();
    const openConfig = (price:Price) => setHash(PortUtils.createHash(price.id, "config"))
    const {account,currency,filter} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()

    const tickers = [Prices.i.get("USD")!, ...portfolio.filter(currency, filter, account, false).filter(holding => !holding.isCashEq).map(holding => holding.price)]
    const bodyCell = (row:Price, col:string) => row.value(col)
    const label = (col:string) => Utils.label(col)
    const rowProps = (row:Price) => ({ onClick : () => openConfig(row) })
    return <>
        <ConfigToolbar/>
        <div id="configs" className="flex1 scroller"><Table tableName="configs" cols={COLS} rows={tickers} tr={rowProps} cellText={bodyCell} label={label} rowKey={r => r.id}/></div>
    </>
}
